let toggleBtn = document.querySelector('.toggle-icon');

function toggleClassOnEvent(el, event, active) {
  let element = document.querySelector(el);
  if (element) {
    element.addEventListener(event, function onClick() {
      toggleBtn.classList.toggle(active);
    })
  }
}

toggleClassOnEvent(".toggle-icon", "click", "active");